const FAQ_ITEMS = [
  {
    id: 1,
    q: '51影院需要注册登录吗？',
    a: '不需要。51影院完全免费，打开网站即可在线观看，无需注册账号或登录，真正做到打开即看。',
  },
  {
    id: 2,
    q: '播放画质怎么样？会卡顿吗？',
    a: '平台采用先进的视频加速技术，支持超清4K画质播放。根据您的网络状况自动适配最佳清晰度，确保流畅不缓冲。',
  },
  {
    id: 3,
    q: '真的有广告吗？',
    a: '51影院承诺全程免广告播放。从点开视频到结束观看，不会有任何贴片广告、弹窗广告或暂停广告打扰您的观影体验。',
  },
  {
    id: 4,
    q: '影视资源更新频率如何？',
    a: '我们每日同步更新，院线新片、热播剧集几乎与主流平台同步上线。资源涵盖了电影、电视剧、综艺、动漫、纪录片等全品类内容。',
  },
  {
    id: 5,
    q: '支持哪些设备观看？',
    a: '51影院全面支持电脑、平板和手机浏览器访问。移动端已做专门适配，在不同设备上都能获得良好的观影体验。',
  },
  {
    id: 6,
    q: '如何推荐影片或反馈问题？',
    a: '您可以通过页面的"联系我们"板块，发送邮件至我们的投稿邮箱，或者关注微信公众号与我们互动。我们非常重视每一位影迷的建议。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600">关于51影院的常见疑问解答</p>
          </div>

          <div className="space-y-3">
            {FAQ_ITEMS.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200 rounded-xl p-5"
              >
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-question-line text-primary-500"></i>
                    </span>
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}